import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useActualites from "./hooks/useActualites";

import ActualiteDetails from "./components/ActualiteDetails";
import ActualiteDrawer from "./components/ActualiteDrawer";
import ActualiteForm from "./components/ActualiteForm";
import ActualitesGrid from "./components/ActualitesGrid";
import ActualitesHero from "./components/ActualitesHero";
import ActualitesStats from "./components/ActualitesStats";
import ActualitesToolbar from "./components/ActualitesToolbar";
import useScrollToTop from "../../../../hooks/useScrollToTop";

export default function Actualites() {
  useScrollToTop();
  const {
    loading,
    saving,
    filters,
    setFilter,
    news,
    filteredNews,
    selectedArticle,
    drawerMode,
    deleteCandidateId,
    stats,
    actions,
  } = useActualites();

  return (
    <div className="space-y-6">
      <ActualitesHero
        loading={loading}
        total={news.length}
        activeCount={stats.active}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshNews}
      />

      <ActualitesStats loading={loading} stats={stats} />

      <ActualitesToolbar
        loading={loading}
        filters={filters}
        setFilter={setFilter}
        totalCount={news.length}
        filteredCount={filteredNews.length}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshNews}
      />

      <ActualitesGrid
        loading={loading}
        articles={filteredNews}
        deleteCandidateId={deleteCandidateId}
        onDetails={actions.openDetailsDrawer}
        onEdit={actions.openEditDrawer}
        onAskDelete={actions.askDelete}
        onCancelDelete={actions.cancelDelete}
        onConfirmDelete={actions.confirmDelete}
      />

      <ActualiteDrawer
        open={Boolean(drawerMode)}
        mode={drawerMode}
        article={selectedArticle}
        onClose={actions.closeDrawer}
      >
        {drawerMode === "details" && selectedArticle && (
          <ActualiteDetails
            article={selectedArticle}
            onEdit={() => actions.openEditDrawer(selectedArticle)}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "create" && (
          <ActualiteForm
            mode="create"
            saving={saving}
            onSubmit={actions.createArticle}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "edit" && selectedArticle && (
          <ActualiteForm
            mode="edit"
            article={selectedArticle}
            saving={saving}
            onSubmit={actions.updateArticle}
            onClose={actions.closeDrawer}
          />
        )}
      </ActualiteDrawer>

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}
